// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"radio__wrapper-3tCMN","radio":"radio__radio-1_9rG","title":"radio__title-3b5lT","label":"radio__label-1LtlI"};


//////////////////
// WEBPACK FOOTER
// ./~/account-ui/radio/radio.css
// module id = 860
// module chunks = 0